import { render, staticRenderFns } from "./TakeMealIndex.vue?vue&type=template&id=4b7d7c87"
import script from "./TakeMealIndex.vue?vue&type=script&lang=js"
export * from "./TakeMealIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports